// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"6bb37a6e","237":"6bb37a6e","468":"6bb37a6e","520":"6bb37a6e"}[chunkId] + ".chunk.css";
};